module.exports = __webpack_public_path__ + "static/media/cccb0810-e697-41f6-a781-4b6246ecbbbe.2221fe2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/cccb0810-e697-41f6-a781-4b6246ecbbbe.jpg
// module id = 852
// module chunks = 0